<div class="full-height-panelbar">
  <kendo-panelbar>
    <kendo-panelbar-item title="" #kendoPanel *ngFor="let widgetGroup of widgetsDefinitions; let i = index;">
      <ng-template kendoPanelBarItemTitle>
        <label>{{widgetGroup.text}}</label>
      </ng-template>
      <ng-template kendoPanelBarContent>
        <ul style="margin: 0; padding: 0;">
          <li *ngFor="let widget of widgetGroup.items; let i = index;" class="widget" (click)="addWidget(widget.config.widgetId)">
            <span>{{widget.WidgetNameEnglish}}</span>
          </li>
        </ul>
      </ng-template>
    </kendo-panelbar-item>
  </kendo-panelbar>
</div>
